import { render, staticRenderFns } from "./support-coupon-form.vue?vue&type=template&id=896b0f70"
import script from "./support-coupon-form.vue?vue&type=script&lang=js"
export * from "./support-coupon-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports